import { CastlabsPlayerService } from './castlabs/CastlabsPlayerService';
import { PlayerService } from './PlayerService';

/**
 * Factory to create configured player service
 */
export class PlayerFactory {
  /**
   * Creates player service
   * @returns {PlayerService}
   */
  static createPlayerService(): PlayerService {
    return new CastlabsPlayerService();
  }
}
